import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const center = objectWithClassName({
  className: [
    `text-center`,
    /** @deprecated Use 'text-center' instead */
    "umd-layout-text-alignment-center"
  ]
});
export {
  center
};
//# sourceMappingURL=inline.js.map
